export  default {
    getUserState(state) {
        return state.userState;
    },
};